import React, { useMemo } from "react";
import { LayerGroup, TileLayer } from "react-leaflet";
import { Markers } from "../shared";
import { useSelector } from "react-redux";
import YandexMutantLayer from "./YandexMutantLayer";

const layersUrl = {
    osm: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
    twogis: "https://tile2.maps.2gis.com/tiles?x={x}&y={y}&z={z}&v=1.1",
    google: 'https://mt1.google.com/vt/lyrs=m@169000000&hl=ru&x={x}&y={y}&z={z}',
    arc: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    googleSatellite: 'https://mt1.google.com/vt/lyrs=s@169000000&hl=ru&x={x}&y={y}&z={z}',
    googleHybrid: 'https://mt1.google.com/vt/lyrs=s,h@169000000&hl=ru&x={x}&y={y}&z={z}',
}

const baseLayers = {
    1: { name: 'Карта(OSM)', url: layersUrl.osm, maxNativeZoom: 20, type: 'tile' },
    2: { name: 'Карта(2GIS)', url: layersUrl.twogis, maxNativeZoom: 16, type: 'tile' },
    3: { name: 'Карта(Yandex)', type: 'yandex', yandexType: 'yandex#map' },
    4: { name: 'Спутник(Yandex)', type: 'yandex', yandexType: 'yandex#satellite' },
    5: { name: 'Гибрид(Yandex)', type: 'yandex', yandexType: 'yandex#hybrid' },
    6: { name: 'Карта(Google)', url: layersUrl.google, maxNativeZoom: 18, type: 'tile' },
    7: { name: 'Спутник(Google)', url: layersUrl.googleSatellite, type: 'tile' },
    8: { name: 'Гибрид(Google)', url: layersUrl.googleHybrid, type: 'tile' },
    9: { name: 'Спутник(ArcGis)', url: layersUrl.arc, type: 'tile' },
}

const ControlLayer = (props) => {
    // const objects = useSelector(state => state.store.objects);
    const { base: baseLayer, overlay: overlayLayers, data: dataLayers } = useSelector(state => state.store.layers) || {};
    
   
 


    return (
        <>
            {/* Базовый слой */}
            {baseLayers[baseLayer || 1] && (
                <>
                    {baseLayers[baseLayer || 1].type === 'tile' && (
                        <TileLayer
                            url={baseLayers[baseLayer || 1].url}
                            keepBuffer={3}
                            key={baseLayer || 1}
                            maxZoom={20}
                            maxNativeZoom={baseLayers[baseLayer || 1].maxNativeZoom || 18}
                        />
                    )}
                    {baseLayers[baseLayer || 1].type === 'yandex' && (
                        <YandexMutantLayer
                            type={baseLayers[baseLayer || 1].yandexType}
                            opacity={1}
                            traffic={false}
                            key={baseLayer || 1}
                        />
                    )}
                </>
            )}

            {/* Overlay слои */}
            {overlayLayers?.crossroad && (
                <LayerGroup>
                    <Markers type="crossroad" />
                </LayerGroup>
            )}

            {overlayLayers?.speed && (
                <LayerGroup>
                    <Markers type="speed" clustering={true} maxClusterRadius={22} showCameraDirection={dataLayers.showCameraDirection} showSpeedLimit={dataLayers.showSpeedLimit}/>
                </LayerGroup>
            )}
            
            {overlayLayers?.parking && (
                <LayerGroup>
                    <Markers type="parking" />
                </LayerGroup>
            )}

            {overlayLayers?.vgk && (
                <LayerGroup>
                    <Markers  type="vgk" />
                </LayerGroup>
            )}

            {overlayLayers?.deact && (
                <LayerGroup>
                    <Markers type="deactivated" />
                </LayerGroup>
            )}
            
            {overlayLayers?.vehicles && (
                <LayerGroup>
                    <Markers type="vehicle" />
                </LayerGroup>
            )} 

            {overlayLayers?.others && (
                Object.keys(overlayLayers?.others).map((key) => {
                    if (!overlayLayers?.others[key]) return null;
                    return (
                        <LayerGroup key={key}>
                            <Markers type={key} clustering={true} maxClusterRadius={40} showCameraDirection={dataLayers.showCameraDirection} showSpeedLimit={dataLayers.showSpeedLimit} />
                        </LayerGroup>
                    )
                })
            )}
        </>
    );
};

ControlLayer.displayName = 'ControlLayer';

export default ControlLayer;
